/**
 * The Supabase dashboard shows several URLs, and the one people copy is often
 * the REST endpoint rather than the project's. The client library appends its
 * own path, so `…supabase.co/rest/v1/` becomes `…/rest/v1/auth/v1/token` and
 * the gateway answers "Invalid path specified in request url" — which says
 * nothing about what to fix. Normalising here turns a cryptic failure at
 * sign-in into no failure at all.
 */
export function normalizeSupabaseUrl(raw: string): string {
  let u = (raw ?? "").trim().replace(/\/+$/, "");
  u = u.replace(/\/(rest|auth|storage|realtime|functions)\/v\d+$/, "");
  return u;
}

export const SUPABASE_URL = normalizeSupabaseUrl(import.meta.env?.VITE_SUPABASE_URL ?? "");
export const SUPABASE_ANON_KEY = import.meta.env?.VITE_SUPABASE_ANON_KEY ?? "";

/** Which required settings are missing. Empty means the app can sign in. */
export function missingConfig(): string[] {
  const out: string[] = [];
  if (!SUPABASE_URL) out.push("VITE_SUPABASE_URL");
  else if (!/^https?:\/\/[^/\s]+$/.test(SUPABASE_URL)) {
    out.push("VITE_SUPABASE_URL (pitää olla pelkkä https://…supabase.co)");
  }
  if (!SUPABASE_ANON_KEY) out.push("VITE_SUPABASE_ANON_KEY");
  return out;
}

/** How long a local copy may go unrefreshed before FR-11.11 warns about it. */
export const STALE_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

export const DB_NAME = "savusauna";
// 2 adds the "rejected" store; 3 re-keys membership on (sauna_id, user_id).
export const DB_VERSION = 3;

/** Attempts before a write the server keeps refusing is set aside. */
export const MAX_ATTEMPTS = 3;
